import createLucideIcon from '../createLucideIcon';

const ChevronsUpDown = createLucideIcon('ChevronsUpDownIcon', [
  ['path', { d: 'm7 15 5 5 5-5', key: '1hf1tw' }],
  ['path', { d: 'm7 9 5-5 5 5', key: 'sgt6xg' }],
]);

export default ChevronsUpDown;
